<template>
  <v-row justify="center">
    <v-dialog
      overlay-opacity="0.8"
      overlay-color="primary"
      :value="addBankDialog"
      persistent
      max-width="800px"
      :content-class="
        addBankDialog ? 'elevation-0 d-flex flex-column align-center' : ''
      "
      transition="scroll-y-transition"
    >
      <v-card flat color="transparent" class="d-flex align-center flex-column">
        <div class="text-h3 secondary--text text-center font-weight-bold mb-5">
          Add Bank Account
        </div>
        <v-card max-width="500px">
          <v-card-text>
            <v-container>
              <div class="d-flex justify-end mt-n4 mr-n2 mb-4">
                <v-btn icon color="secondary" @click="closeDialog">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </div>
              <v-row>
                <v-col class="d-flex" cols="12">
                  <v-select
                    :loading="isFetchingBanks"
                    v-model="selectedBank"
                    :items="allBanks"
                    item-text="name"
                    return-object
                    label="Choose Your Bank"
                    outlined
                  >
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    :disabled="selectedBank == null"
                    v-model="accountNumber"
                    :loading="isResolvingAccountNumber"
                    outlined
                    label="Enter Account Number"
                    required
                    type="number"
                    :hint="
                      resolvedAccountNumber
                        ? `Resolved: ${resolvedAccountNumber}`
                        : ''
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="sentOTP">
                  <v-text-field
                    :disabled="!resolvedAccountNumber"
                    v-model="otp"
                    :loading="isResolvingAccountNumber"
                    outlined
                    label="Enter OTP"
                    required
                    type="number"
                    
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!sentOTP"
              :loading="requestingOTP"
              color="success"
              text
              @click="requestOTP"
              :disabled="!resolvedAccountNumber"
              >Request OTP</v-btn
            >
            <v-btn v-else
              :loading="isResolvingAccountNumber || isAddingBankAccount"
              color="success"
              text
              @click="addBankAccount"
              :disabled="!resolvedAccountNumber"
              >Proceed</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { BankAccountService, UserService } from "@/services/index.js";
import allBanks from "@/utils/nigerianBanks.js";

export default {
  props: {
    addBankDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      accountNumber: null,
      isAddingBankAccount: false,
      isResolvingAccountNumber: false,
      requestingOTP: false,
      sentOTP: false,
      isFetchingBanks: false,
      selectedBank: null,
      resolvedAccountNumber: null,
      allBanks: [],
      otp: ''
    };
  },
  methods: {
    closeDialog() {
      this.accountNumber = null;
      this.selectedBank = null;
      this.$emit("toggleDialog", false);
    },
    async requestOTP() {
      this.requestingOTP = true;
      this.sentOTP = false;

      try {
        const { message } =  await UserService.requestOTP("addbank");
        this.$store.commit('openSnackbar', message);

        this.sentOTP = true;
        this.requestingOTP = false;
      } catch (err) {
        this.requestingOTP = false;
      }
    },
    async getAllBanks() {
      try {
        // this.isFetchingBanks = true;
        // let res = await BankAccountService.getAllBanks();
        // let banks = Object.entries(allBanks).map(el => {
        //     return { code: el[0], name: el[1] }
        // })
        let banks = [];

        Object.entries(allBanks).forEach((el) => {
          banks.push({ code: el[0], name: el[1] });
        });
        this.allBanks = banks;
        // console.log(Object.entries(allBanks))

        // this.isFetchingBanks = false;

        // console.log(res);
      } catch (error) {
        this.isFetchingBanks = false;
        // throw error;
      }
    },
    async addBankAccount() {
      try {
        this.isAddingBankAccount = true;

        let res = await BankAccountService.add({
          accountnumber: this.accountNumber,
          bankcode: this.selectedBank.code,
          otp: this.otp
        });

        this.$store.commit("openSnackbar", res.message);
        // this.getAllBanks();
        this.isAddingBankAccount = false;
        this.$emit("addBank");
        this.$emit("toggleDialog", false);
        // this.addBankDialog = false;
      } catch (error) {
        this.isAddingBankAccount = false;
        // throw error;
      }
    },
    async resolveAccountNumber() {
      try {
        this.isResolvingAccountNumber = true;

        const { account_name } = await BankAccountService.resolve(
          this.accountNumber,
          this.selectedBank.code
        );

        // let res = await BankAccountService.resolve(
        //   this.accountNumber,
        //   this.selectedBank.code
        // );

        this.resolvedAccountNumber = account_name;
        // console.log(account_name);
        this.isResolvingAccountNumber = false;
      } catch (error) {
        // console.log(error);
        this.isResolvingAccountNumber = false;
        // throw error;
      }
    },
  },
  mounted() {
    this.getAllBanks();
  },
  watch: {
    accountNumber(v) {
      this.resolvedAccountNumber = null;
      this.sentOTP = false;
      if (v && v.length == 10) {
        this.resolveAccountNumber();
      }
    },
    selectedBank() {
      this.resolvedAccountNumber = null;
    },

  },
};
</script>
